module.exports = __webpack_public_path__ + "img/0.af2cdd17.webp";